import { Component, OnDestroy, OnInit } from '@angular/core';
import { CustomFieldViewComponent, Form } from '../../../../../base/form';
import { ApiService } from '../../../../../services/api.service';
import { ViewService } from '../../../../../services/view.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AssetTypeFaultSeverity } from '../../types';
import { arr_map, blank, data_get, filled, observe } from '../../../../../shared/utils/common';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'asset-types-view-fault-codes',
  template: `
    <div fieldmagicGridRow>
      <div fieldmagicGridColumn="12">
        <table class="table table-bordered">
          <thead>
            <tr>
              <td
                colspan="2"
                width="30%"
              >
                <fieldmagic-text
                  content="Defects"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>
              <td
                width="50%"
              >
                <fieldmagic-text
                  content="Description"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>
              <td
                width="20%"
              >
                <fieldmagic-text
                  content="Linked Product"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>
            </tr>
          </thead>

          <tbody>
            <ng-container *ngIf="fetching$ | async">
              <tr class="text-center">
                <td colspan="4">
                  <fieldmagic-icon [spin]="true"></fieldmagic-icon>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="! (fetching$ | async)">
              <ng-container *ngIf="severities$ | async as severities">
                <tr
                  *ngIf="severities | blank"
                  class="text-center"
                >
                  <td colspan="4">{{ 'No possible defects available.' | translate }}</td>
                </tr>

                <ng-container *ngFor="let severity of severities; let index = index">
                  <tr
                    [style.background]="severity.color"
                    [style.color]="severity.color | bg_text_color"
                  >
                    <td
                      colspan="4"
                      style="padding: 6px;"
                    >
                      <div class="d-flex d-flex-gap align-items-center">
                        {{ severity.severity }}
                      </div>
                    </td>
                  </tr>

                  <tr *ngFor="let fault of severity.faults">
                    <td
                      width="2%"
                      style="border-right: 0; padding-right: 0;"
                    >
                      <div class="bg-indent"></div>
                    </td>
                    <td style="padding: 6px; border-left: 0; padding-left: 8px;">
                      {{ fault.fault }}
                    </td>
                    <td>
                      {{ fault.description | placeholdWithString }}
                    </td>
                    <td>
                      <fieldmagic-text-link
                        [segments]="['/items', fault.item_id]"
                        [label]="fault.item_text"
                        [openNewTab]="true"
                      >
                      </fieldmagic-text-link>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  `
})
export class AssetTypeViewFaultCodesComponent implements CustomFieldViewComponent, OnInit, OnDestroy {
  readonly fetching$ = new BehaviorSubject<boolean>(true);
  readonly severities$ = new BehaviorSubject<AssetTypeFaultSeverity[]>([]);

  private _onFetchingSeveritiesSubscription?: Subscription;

  constructor(
    private readonly _api: ApiService,
    private readonly _view: ViewService,
  ) {}

  ngOnInit(): void {
    const id = data_get(this._view.getViewRecord(), 'id');

    if (blank(id)) {
      this.fetching$.next(false);
    } else {
      this._onFetchingSeveritiesSubscription = observe({
        after: () => this.fetching$.next(false),
        observable: () => this._api.callPrivate$({
          path: '/asset_types/fault_codes',
          action: 'post',
          body: {
            'asset_type_id': id,
          },
          onSuccessResponse: (response) => arr_map(response.get('items'), {
            transformer: (variant) => ({
              ... variant,
            })
          }),
        }),
      })
      .pipe(
        filter(filled)
      )
      .subscribe((variants) => this.severities$.next(variants));
    }
  }

  ngOnDestroy(): void {
    if (this._onFetchingSeveritiesSubscription) {
      this._onFetchingSeveritiesSubscription.unsubscribe();
    }
  }

  /// do nothing as its not dependent to this data
  setField(field: Form<any>): void {}
}